import { useState } from "react";
import InputsOrder from "./InputsOrder";

export default function SetOrder({
  accountData,
  calculatorInsertRequest,
  marketData,
  symbol,
  selectedSide: controlledSelectedSide,
  onSelectedSideChange,
  onTradeNotification,
  className = "",
}) {
  const [uncontrolledSelectedSide, setUncontrolledSelectedSide] =
    useState("buy");
  const selectedSide = controlledSelectedSide ?? uncontrolledSelectedSide;
  const setSelectedSide =
    onSelectedSideChange ?? setUncontrolledSelectedSide;

  return (
    <div className={`w-full flex flex-col gap-2.5 ${className}`}>
      <div className="w-full rounded-full flex bg-zi-bg1-light dark:bg-zi-bg1-dark">
        <button
          onClick={() => setSelectedSide("buy")}
          className={`w-full rounded-full py-2 flex justify-center items-center outline-none ${
            selectedSide === "buy"
              ? "bg-zi-green-dark text-white"
              : " text-zi-text-light dark:text-zi-text-dark hocus:bg-zi-bg1-dark/10 hocus:dark:bg-zi-bg1-dark/50"
          }`}
        >
          خرید
        </button>

        <button
          onClick={() => setSelectedSide("sell")}
          className={`w-full rounded-full py-2 flex justify-center items-center outline-none ${
            selectedSide === "sell"
              ? "bg-zi-red-dark text-white"
              : "text-zi-text-light dark:text-zi-text-dark hocus:bg-zi-bg1-dark/10 hocus:dark:bg-zi-bg1-dark/50"
          }`}
        >
          فروش
        </button>
      </div>

      <InputsOrder
        accountData={accountData}
        calculatorInsertRequest={calculatorInsertRequest}
        marketData={marketData}
        selectedSide={selectedSide}
        symbol={symbol}
        onTradeNotification={onTradeNotification}
      />
    </div>
  );
}
